import React from 'react';

/** A simple wait function to test components with animations */
export const wait = (timeToDelay: number) =>
  new Promise(resolve => setTimeout(resolve, timeToDelay));

export const Placeholder = (props: {
  children?: React.ReactNode;
  height?: string | number;
}) => (
  <div
    style={{
      border: '1px dashed #162D3D',
      color: '#162D3D',
      display: 'block',
      width: '100%',
      height: props.height || '100%',
      textAlign: 'center',
      boxSizing: 'border-box',
    }}
  >
    {props.children}
  </div>
);

export const clickElement = (dataHook: string) => {
  const node = document.body;
  const dataHookSelector = `[data-hook*=${dataHook}]`;
  const element = node.querySelector<HTMLElement>(dataHookSelector);
  element?.click();
};

export const focusElement = (dataHook: string) => {
  const node = document.body;
  const dataHookSelector = `[data-hook*=${dataHook}]`;
  const element = node.querySelector<HTMLElement>(dataHookSelector);
  element?.focus();
};

export * from './types';
export * from './addStories';
